export const PROFILE_PICTURE_CONFLICT = 'PROFILE_PICTURE_CONFLICT';
export const IDEMPOTENCY_KEY_REUSED = 'IDEMPOTENCY_KEY_REUSED';

const PENDING_STATUSES = new Set([
  'preparing',
  'awaiting_upload',
  'upload_processing',
  'commit_pending',
  'propagation_pending',
]);

export function isCommittedResult(result) {
  return Boolean(result && result.operation && result.operation.committed === true);
}

export function isPendingResult(result) {
  if (!result || !result.operation) return false;
  if (result.operation.committed === true) return false;
  if (result.httpStatus === 202) return true;
  if (result.httpStatus === 200 && result.operation.committed === false) return true;
  if (result.httpStatus === 201 && result.operation.status === 'awaiting_upload') return false;
  return PENDING_STATUSES.has(result.operation.status);
}

export function resolveRetryDelayMs(result, attempt = 0) {
  const header = result && result.retryAfterHeader;
  const bodySeconds = result && result.operation && result.operation.retryAfterSeconds;
  let seconds = null;
  if (header != null && header !== '') {
    const parsed = Number(header);
    if (!Number.isNaN(parsed)) seconds = parsed;
  }
  if (seconds == null && bodySeconds != null) {
    seconds = Number(bodySeconds);
  }
  if (seconds == null || Number.isNaN(seconds) || seconds < 0) {
    // Bounded exponential backoff: 1s, 2s, 4s … capped at 15s
    return Math.min(15000, 1000 * 2 ** Math.min(attempt, 4));
  }
  return Math.min(15000, Math.max(250, seconds * 1000));
}

export async function readErrorPayload(error) {
  const response = error && error.response;
  if (!response || typeof response.json !== 'function') {
    return { status: response && response.status, body: null };
  }
  try {
    const body = await response.json();
    return { status: response.status, body };
  } catch (err) {
    return { status: response.status, body: null };
  }
}

export function errorCodeFromPayload(payload) {
  if (!payload || !payload.body) return null;
  return payload.body.error_code || payload.body.errorCode || null;
}
